import link from './link'

export const fields = `
  links[] {
    ${link.fields}
  },
  stickyBanner {
    isEnabled,
    backgroundColor,
    textColor,
    expiresAtRefresh,
    showOnAllPages,
    specificPages[]-> {
      _id,
      title,  
      slug,
    },
    text,
    link {
      ${link.fields}
    },
    image {
      asset-> {
        url
      }
    },
  }
`

export const fragment = (name = 'navigation') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
